/**
 * Fieltros Olleros - Sistema de Selector de Medidas
 * ==================================================
 * Valida medidas segun el tipo de fieltro y ancho seleccionado
 */

(function() {
  'use strict';

  // ============================================
  // CONFIGURACION DE REGLAS POR TIPO DE FIELTRO
  // ============================================
  // Las claves pueden ser handles de coleccion o tags (tipo:xxx)
  // El sistema busca coincidencias parciales
  window.fieltroRules = {
    'extra-feltina': {
      name: 'Extra Feltina',
      widths: {
        '80cm': { min: 10, max: 300, step: 10, unit: 'cm', type: 'length' },
        '1.60m': { min: 10, max: null, step: 10, unit: 'cm', type: 'length' },
        '1,60m': { min: 10, max: null, step: 10, unit: 'cm', type: 'length' },
        '30x40cm': { min: 1, max: null, step: 1, unit: 'uds', type: 'units' }
      }
    },
    'extra-feltina-jaspeado': {
      name: 'Extra Feltina Jaspeado',
      widths: {
        '90cm': { min: 10, max: 300, step: 10, unit: 'cm', type: 'length' },
        '0.90cm': { min: 10, max: 300, step: 10, unit: 'cm', type: 'length' },
        '0,90cm': { min: 10, max: 300, step: 10, unit: 'cm', type: 'length' },
        '1.80m': { min: 10, max: null, step: 10, unit: 'cm', type: 'length' },
        '1,80m': { min: 10, max: null, step: 10, unit: 'cm', type: 'length' },
        '30x45cm': { min: 1, max: null, step: 1, unit: 'uds', type: 'units' }
      }
    },
    'deco': {
      name: 'Deco',
      widths: {
        '80cm': { min: 10, max: 300, step: 10, unit: 'cm', type: 'length' },
        '1.80m': { min: 10, max: null, step: 10, unit: 'cm', type: 'length' },
        '1,80m': { min: 10, max: null, step: 10, unit: 'cm', type: 'length' },
        '20x30cm': { min: 1, max: null, step: 1, unit: 'uds', type: 'units' }
      }
    },
    'artesania': {
      name: 'Artesania',
      widths: {
        '90cm': { min: 10, max: 300, step: 10, unit: 'cm', type: 'length' },
        '0.90cm': { min: 10, max: 300, step: 10, unit: 'cm', type: 'length' },
        '0,90cm': { min: 10, max: 300, step: 10, unit: 'cm', type: 'length' },
        '1.80m': { min: 10, max: null, step: 10, unit: 'cm', type: 'length' },
        '1,80m': { min: 10, max: null, step: 10, unit: 'cm', type: 'length' },
        '30x45cm': { min: 1, max: null, step: 1, unit: 'uds', type: 'units' }
      }
    },
    'felt': {
      name: 'Felt',
      widths: {
        '1.60m': { min: 50, max: null, step: 10, unit: 'cm', type: 'length' },
        '1,60m': { min: 50, max: null, step: 10, unit: 'cm', type: 'length' }
      }
    },
    'texfel-500': {
      name: 'Texfel 500',
      widths: {
        '100cm': { min: 10, max: null, step: 10, unit: 'cm', type: 'length' },
        '1m': { min: 10, max: null, step: 10, unit: 'cm', type: 'length' },
        '20x30cm': { min: 1, max: null, step: 1, unit: 'uds', type: 'units' }
      }
    },
    'acrilico-estampado': {
      name: 'Acrilico estampado',
      widths: {
        '90cm': { min: 50, max: null, step: 10, unit: 'cm', type: 'length' },
        '0.90cm': { min: 50, max: null, step: 10, unit: 'cm', type: 'length' },
        '0,90cm': { min: 50, max: null, step: 10, unit: 'cm', type: 'length' },
        '30x45cm': { min: 1, max: null, step: 1, unit: 'uds', type: 'units' }
      }
    }
  };

  // ============================================
  // ALIAS PARA NOMBRES DE COLECCION
  // ============================================
  // Mapea handles de coleccion a los tipos definidos en fieltroRules
  window.fieltroAliases = {
    // Extra Feltina
    'extra-feltina': 'extra-feltina',
    'feltina': 'extra-feltina',

    // Extra Feltina Jaspeado
    'extra-feltina-jaspeado': 'extra-feltina-jaspeado',
    'jaspeado': 'extra-feltina-jaspeado',
    'jaspeados': 'extra-feltina-jaspeado',

    // Deco
    'fieltros-deco-3mm-grueso': 'deco',
    'fieltros-deco': 'deco',
    'deco': 'deco',

    // Artesania
    'fieltros-artesania': 'artesania',
    'artesania': 'artesania',

    // Felt
    'color-felt': 'felt',
    'felt': 'felt',

    // Texfel 500
    'texfel-500-3mm-grueso': 'texfel-500',
    'texfel-500': 'texfel-500',
    'texfel': 'texfel-500',

    // Acrilico / Estampado (usan las mismas reglas)
    'fieltro-acrilico': 'acrilico-estampado',
    'fieltro-estampado': 'acrilico-estampado',
    'acrilico': 'acrilico-estampado',
    'estampado': 'acrilico-estampado'
  };

  // ============================================
  // MENSAJES DE ERROR EN ESPANOL
  // ============================================
  var errorMessages = {
    minNotMet: 'La medida minima es {min} {unit}',
    maxExceeded: 'La medida maxima es {max} {unit}',
    notMultiple: 'La medida debe ser multiplo de {step}',
    required: 'Por favor, introduce una medida',
    invalidNumber: 'Por favor, introduce un numero valido',
    optionDisabled: 'Esta opción no está disponible actualmente'
  };

  // ============================================
  // CLASE PRINCIPAL: FieltroMeasureSelector
  // ============================================
  function FieltroMeasureSelector(container) {
    this.$container = $(container);
    this.sectionId = this.$container.data('section-id');
    this.fieltroType = this.resolveType(this.$container.data('fieltro-type'));
    this.rules = window.fieltroRules[this.fieltroType] || null;
    this.currentVariant = null;
    this.currentRules = null;
    this.pricePerUnit = parseInt(this.$container.data('variant-price')) || 0;

    // Elementos del DOM
    this.$input = this.$container.find('.js-fieltro-input');
    this.$unit = this.$container.find('.js-fieltro-unit');
    this.$hint = this.$container.find('.js-fieltro-hint');
    this.$error = this.$container.find('.js-fieltro-error');
    this.$totalPrice = this.$container.find('.js-fieltro-total-price');
    this.$widthInput = this.$container.find('.js-fieltro-width');
    this.$quantityInput = this.$container.find('.js-fieltro-quantity');
    this.$lengthWrapper = this.$container.find('.js-fieltro-length');

    this.init();
  }

  FieltroMeasureSelector.prototype = {
    resolveType: function(type) {
      if (!type) return '';
      type = type.toLowerCase().trim();

      // Buscar coincidencia exacta en reglas
      if (window.fieltroRules[type]) {
        return type;
      }

      // Buscar en alias
      if (window.fieltroAliases[type]) {
        return window.fieltroAliases[type];
      }

      // Buscar coincidencia parcial en reglas
      for (var key in window.fieltroRules) {
        if (window.fieltroRules.hasOwnProperty(key)) {
          if (type.indexOf(key) !== -1 || key.indexOf(type) !== -1) {
            return key;
          }
        }
      }

      // Buscar coincidencia parcial en alias
      for (var alias in window.fieltroAliases) {
        if (window.fieltroAliases.hasOwnProperty(alias)) {
          if (type.indexOf(alias) !== -1 || alias.indexOf(type) !== -1) {
            return window.fieltroAliases[alias];
          }
        }
      }

      return type;
    },

    init: function() {
      if (!this.rules) {
        console.warn('FieltroMeasure: No se encontraron reglas para el tipo:', this.fieltroType);
        // Si no hay reglas, usar valores por defecto
        this.currentRules = { min: 10, max: null, step: 5, unit: 'cm', type: 'length' };
        this.updateUI();
        this.$input.val(10);
      }

      this.bindEvents();
      this.listenToVariantChanges();
      this.initCurrentVariant();
    },

    bindEvents: function() {
      var self = this;

      // Input de medida - validar en cada cambio
      this.$input.on('input', function() {
        self.validateAndUpdate();
      });

      // Al perder el foco, redondear al multiplo mas cercano
      this.$input.on('blur', function() {
        self.roundToStep();
        self.validateAndUpdate();
      });

      // Prevenir envio del formulario si hay errores
      this.$container.closest('form').on('submit', function(e) {
        if (!self.validate()) {
          e.preventDefault();
          e.stopPropagation();
          self.$input.focus();
          return false;
        }
      });
    },

    listenToVariantChanges: function() {
      var self = this;

      // Escuchar el evento personalizado del tema Impulse
      $(document).on('variantChange', function(evt) {
        if (evt.variant) {
          self.onVariantChange(evt.variant);
        }
      });

      // Escuchar cambios en el select de variantes
      var $form = this.$container.closest('form');
      
      // Para selects directos de variante
      $form.on('change', 'select[name="id"]', function() {
        var $selected = $(this).find('option:selected');
        
        // Verificar si la opción está deshabilitada
        if ($selected.prop('disabled') || $selected.attr('disabled') === 'disabled') {
          self.currentVariant = null;
          self.updateAddToCartButton(false);
          self.showError(errorMessages.optionDisabled);
          return;
        }
        
        var variantId = $(this).val();
        self.findAndSetVariant(variantId);
      });

      // Escuchar cambios en dropdowns de opciones (SingleOptionSelector)
      $form.on('change', '.variant__input-' + this.sectionId, function() {
        setTimeout(function() {
          var $optionSelect = $form.find('select[name="id"]');
          if ($optionSelect.length) {
            var $selected = $optionSelect.find('option:selected');
            
            // Verificar si la opción está deshabilitada
            if ($selected.prop('disabled') || $selected.attr('disabled') === 'disabled') {
              self.currentVariant = null;
              self.updateAddToCartButton(false);
              self.showError(errorMessages.optionDisabled);
              return;
            }
            
            self.findAndSetVariant($optionSelect.val());
          }
        }, 100);
      });
      
      // También escuchar cambios directos en los selects de opciones
      $form.on('change', '.variant-input-wrap select', function() {
        setTimeout(function() {
          var $variantSelect = $form.find('select[name="id"]');
          if ($variantSelect.length) {
            var $selected = $variantSelect.find('option:selected');
            
            if ($selected.prop('disabled') || $selected.attr('disabled') === 'disabled') {
              self.currentVariant = null;
              self.updateAddToCartButton(false);
              self.showError(errorMessages.optionDisabled);
              return;
            }
            
            self.findAndSetVariant($variantSelect.val());
          }
        }, 100);
      });
    },

    findAndSetVariant: function(variantId) {
      var $variantJson = $('#VariantsJson-' + this.sectionId);
      if (!$variantJson.length) return;

      try {
        var variants = JSON.parse($variantJson.text().trim());
        
        // Verificar si la opción seleccionada está deshabilitada
        var $selectedOption = this.$container.find('select[name="id"] option:selected, .variant-input-wrap select option:selected');
        var isOptionDisabled = $selectedOption.prop('disabled') || $selectedOption.attr('disabled') === 'disabled';
        
        if (isOptionDisabled) {
          console.log('Opción deshabilitada seleccionada');
          // No buscar variante, directamente deshabilitar el botón
          this.currentVariant = null;
          this.updateAddToCartButton(false);
          this.showError(errorMessages.optionDisabled);
          return;
        }
        
        for (var i = 0; i < variants.length; i++) {
          if (variants[i].id == variantId) {
            this.onVariantChange(variants[i]);
            break;
          }
        }
      } catch (e) {
        console.warn('FieltroMeasure: Error al parsear variantes', e);
      }
    },

    initCurrentVariant: function() {
      var variantId = this.$container.data('variant-id');
      if (variantId) {
        this.findAndSetVariant(variantId);
      } else {
        // Intentar obtener del select
        var $form = this.$container.closest('form');
        var $select = $form.find('select[name="id"]');
        if ($select.length && $select.val()) {
          // Verificar si la opción seleccionada está deshabilitada
          var $selected = $select.find('option:selected');
          if ($selected.prop('disabled') || $selected.attr('disabled') === 'disabled') {
            this.currentVariant = null;
            this.updateAddToCartButton(false);
            this.showError(errorMessages.optionDisabled);
            return;
          }
          this.findAndSetVariant($select.val());
        }
      }
    },

    onVariantChange: function(variant) {
      this.currentVariant = variant;
      
      // Asegurar que available se interpreta correctamente
      if (this.currentVariant) {
        // Convertir a booleano si viene como número o string
        this.currentVariant.available = 
          this.currentVariant.available === true || 
          this.currentVariant.available === 1 || 
          this.currentVariant.available === 'true';
      }
      
      this.pricePerUnit = variant.price;

      // Obtener el ancho desde el titulo de la variante
      var width = this.normalizeWidth(variant.title);
      this.currentRules = this.getRulesForWidth(width);

      // Actualizar el input oculto del ancho
      this.$widthInput.val(variant.title);

      if (this.currentRules) {
        this.updateUI();

        // Establecer valor inicial si esta vacio o es menor al minimo
        var currentVal = parseInt(this.$input.val());
        if (!currentVal || currentVal < this.currentRules.min) {
          this.$input.val(this.currentRules.min);
        }

        this.validateAndUpdate();
      }
    },

    normalizeWidth: function(variantTitle) {
      // Normaliza el titulo de variante para coincidir con las claves de rules
      if (!variantTitle) return '';
      return variantTitle
        .toLowerCase()
        .trim()
        .replace(/\s+/g, '')
        .replace(/,/g, '.');
    },

    getRulesForWidth: function(width) {
      if (!this.rules || !this.rules.widths) {
        return { min: 10, max: null, step: 5, unit: 'cm', type: 'length' };
      }

      var widths = this.rules.widths;

      // Buscar coincidencia exacta
      if (widths[width]) {
        return widths[width];
      }

      // Buscar coincidencia parcial (el ancho puede estar en cualquier parte del titulo)
      for (var key in widths) {
        if (widths.hasOwnProperty(key)) {
          var normalizedKey = key.toLowerCase().replace(/\s+/g, '').replace(/,/g, '.');
          if (width.indexOf(normalizedKey) !== -1 || normalizedKey.indexOf(width) !== -1) {
            return widths[key];
          }
        }
      }

      // Si no hay coincidencia, devolver reglas por defecto
      return { min: 10, max: null, step: 5, unit: 'cm', type: 'length' };
    },

    updateUI: function() {
      if (!this.currentRules) return;

      var rules = this.currentRules;

      // Actualizar unidad
      this.$unit.text(rules.unit);

      // Actualizar atributos del input
      this.$input.attr({
        'min': rules.min,
        'max': rules.max || '',
        'step': rules.step
      });

      // Actualizar hint
      var hintText = 'Min: ' + rules.min + ' ' + rules.unit;
      if (rules.max) {
        hintText += ' | Max: ' + rules.max + ' ' + rules.unit;
      }
      if (rules.step > 1) {
        hintText += ' | Multiplos de ' + rules.step;
      }
      this.$hint.text(hintText);

      // Actualizar label segun tipo
      var $label = this.$lengthWrapper.find('.fieltro-measure__label');
      if (rules.type === 'units') {
        $label.text('Cantidad (unidades)');
      } else {
        $label.text('Medida (cm)');
      }
    },

    roundToStep: function() {
      if (!this.currentRules) return;

      var value = parseInt(this.$input.val());
      if (isNaN(value)) return;

      var step = this.currentRules.step;
      var rounded = Math.round(value / step) * step;

      // Asegurar que esta dentro de los limites
      rounded = Math.max(rounded, this.currentRules.min);
      if (this.currentRules.max) {
        rounded = Math.min(rounded, this.currentRules.max);
      }

      this.$input.val(rounded);
    },

    validate: function() {
      if (!this.currentRules) return true;

      var value = parseInt(this.$input.val());
      var rules = this.currentRules;

      // Requerido
      if (isNaN(value) || this.$input.val() === '') {
        this.showError(errorMessages.required);
        return false;
      }

      // Minimo
      if (value < rules.min) {
        this.showError(errorMessages.minNotMet
          .replace('{min}', rules.min)
          .replace('{unit}', rules.unit));
        return false;
      }

      // Maximo
      if (rules.max && value > rules.max) {
        this.showError(errorMessages.maxExceeded
          .replace('{max}', rules.max)
          .replace('{unit}', rules.unit));
        return false;
      }

      // Multiplo
      if (value % rules.step !== 0) {
        this.showError(errorMessages.notMultiple
          .replace('{step}', rules.step));
        return false;
      }

      this.clearError();
      return true;
    },

    validateAndUpdate: function() {
      var isValid = this.validate();
      this.updatePrice();
      this.updateAddToCartButton(isValid);
      this.updateQuantityForPrice();
      return isValid;
    },

    updateQuantityForPrice: function() {
      if (!this.currentRules) return;

      var value = parseInt(this.$input.val());
      if (isNaN(value)) return;

      // Para que Shopify calcule el precio correctamente:
      // - Si el precio de variante es por 10cm, quantity = medida / 10
      // - Si el precio es por unidad (laminas), quantity = medida
      if (this.currentRules.type === 'units') {
        this.$quantityInput.val(value);
      } else {
        // Asumiendo que el precio es por 10cm
        this.$quantityInput.val(Math.ceil(value / 10));
      }
    },

    updatePrice: function() {
      if (!this.currentRules || !this.pricePerUnit) {
        this.$totalPrice.text('--');
        return;
      }

      var value = parseInt(this.$input.val());
      if (isNaN(value)) {
        this.$totalPrice.text('--');
        return;
      }

      var totalPrice;

      if (this.currentRules.type === 'units') {
        // Para unidades, el precio es precio_variante * cantidad
        totalPrice = this.pricePerUnit * value;
      } else {
        // Para medidas en cm, asumiendo que el precio de variante es por 10cm
        var pricePerCm = this.pricePerUnit / 10;
        totalPrice = pricePerCm * value;
      }

      // Formatear precio
      var formattedPrice = this.formatMoney(totalPrice);
      this.$totalPrice.text(formattedPrice);
    },

    formatMoney: function(cents) {
      // Usar la funcion del tema si esta disponible
      if (typeof theme !== 'undefined' && theme.Currency && theme.Currency.formatMoney) {
        return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
      }

      // Fallback: formato basico en euros
      var amount = (cents / 100).toFixed(2);
      return amount.replace('.', ',') + ' EUR';
    },

    updateAddToCartButton: function(isValid) {
      var $addToCart = $('#AddToCart-' + this.sectionId);
      
      if (!$addToCart.length) {
        $addToCart = this.$container.closest('form').find('[type="submit"]');
      }
      
      if (!$addToCart.length) return;
      
      // Verificar si la opción seleccionada está deshabilitada
      var $selectedOption = this.$container.find('select[name="id"] option:selected, .variant-input-wrap select option:selected');
      var isOptionDisabled = $selectedOption.prop('disabled') || $selectedOption.attr('disabled') === 'disabled';
      
      // Verificar disponibilidad de la variante
      var variantAvailable = this.currentVariant && 
        (this.currentVariant.available === true || 
         this.currentVariant.available === 1 || 
         this.currentVariant.available === 'true');
      
      // El botón se habilita SOLO si:
      // 1. La opción NO está deshabilitada
      // 2. La medida es válida
      // 3. Hay una variante seleccionada
      // 4. La variante tiene stock
      if (!isOptionDisabled && isValid && this.currentVariant && variantAvailable) {
        $addToCart.prop('disabled', false).removeClass('btn--disabled');
      } else {
        $addToCart.prop('disabled', true).addClass('btn--disabled');
      }
    },

    showError: function(message) {
      this.$error.text(message).addClass('is-visible');
      this.$input.addClass('has-error');
    },

    clearError: function() {
      this.$error.text('').removeClass('is-visible');
      this.$input.removeClass('has-error');
    }
  };

  // ============================================
  // INICIALIZACION
  // ============================================
  function initFieltroMeasure() {
    $('.fieltro-measure').each(function() {
      // Evitar doble inicializacion
      if (!$(this).data('fieltro-initialized')) {
        new FieltroMeasureSelector(this);
        $(this).data('fieltro-initialized', true);
      }
    });
  }

  // Inicializar cuando el DOM este listo
  $(document).ready(function() {
    initFieltroMeasure();
  });

  // Re-inicializar en carga de secciones (para editor de Shopify)
  $(document).on('shopify:section:load', function(evt) {
    var $section = $(evt.target);
    $section.find('.fieltro-measure').each(function() {
      if (!$(this).data('fieltro-initialized')) {
        new FieltroMeasureSelector(this);
        $(this).data('fieltro-initialized', true);
      }
    });
  });

  // Exponer para uso externo si es necesario
  window.FieltroMeasureSelector = FieltroMeasureSelector;
  window.initFieltroMeasure = initFieltroMeasure;

})();